import { getParameterByName } from 'Utils/formatters';

export { useYoutubePlayer as default } from '@crehana/react-hooks';

export const getYTembedId = (url: string) => {
  if (url.includes('embed')) {
    const parts = url.split('/');
    const last = parts.length - 1;

    return parts[last];
  }
  const videoId = getParameterByName('v', url);

  return videoId || undefined;
};
